import { render } from "./UiDelete.vue?vue&type=template&id=67a360a2&scoped=true&lang=pug"
import script from "./UiDelete.vue?vue&type=script&lang=js"
export * from "./UiDelete.vue?vue&type=script&lang=js"

import "./UiDelete.vue?vue&type=style&index=0&id=67a360a2&lang=sass&scoped=true"

import exportComponent from "D:\\Front\\project\\valeriya.artist\\valeriya.artist.admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a360a2"]])

export default __exports__